module.exports = __webpack_public_path__ + "img/mind_template_item_5_1.86d61344.png";